
import {  UPDATEOFFERS } from "../../utils/api";
import axios from "../../utils/axios"; 

export const UpdateOffersApi = async (params) => {
    const res = await axios.post(UPDATEOFFERS, params);
    return res;
  };

